<div class="flex-grow sidenav-container min-h-full">
  <div class="sidenav" *ngIf="!isPhysician">
    <div class="sidenav-title">Menu</div>

    <div
      class="sidenav-item"
      routerLink="/home"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/home-icon.svg" alt="">
      Home
      <div class="active-marker"></div>
    </div>

    <a
      *ngIf="enableNewReactApp"
      class="sidenav-item sidenav-item--external"
      [href]="'/rc/patient/' + selectedFacilityId"
      target="_self"
      title="Open Patients in the new app"
    >
      <img src="/assets/users.svg" alt="">
      Patients
      <div class="active-marker"></div>
    </a>

    <div
      *ngIf="!enableNewReactApp"
      class="sidenav-item"
      [routerLink]="['/patient', selectedFacilityId]"
      [class.active]="isPatientsActive"
    >
      <img src="/assets/users.svg" alt="">
      Patients
      <div class="active-marker"></div>
    </div>

    <div
      class="sidenav-item"
      routerLink="/corporation"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/office-building.svg" alt="">
      Corporations
      <div class="active-marker"></div>
    </div>

    <div
      class="sidenav-item"
      routerLink="/facility"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/office-building.svg" alt="">
      Facilities
      <div class="active-marker"></div>
    </div>

    <!--
      In UAT and production, Users and Agenda live in the new RC app at /rc/*.
      Other environments stay on legacy routes because the React app is not
      deployed there.
    -->
    <a
      *ngIf="enableNewReactApp"
      class="sidenav-item sidenav-item--external"
      href="/rc/user"
      target="_self"
      title="Open Users in the new app"
    >
      <img src="/assets/users.svg" alt="">
      Users
      <div class="active-marker"></div>
    </a>

    <div
      *ngIf="!enableNewReactApp"
      class="sidenav-item"
      routerLink="/user"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/users.svg" alt="">
      Users
      <div class="active-marker"></div>
    </div>

    <a
      *ngIf="enableNewReactApp"
      class="sidenav-item sidenav-item--external"
      href="/rc/agenda"
      target="_self"
      title="Open Agenda in the new app"
    >
      <img src="/assets/clipboard-copy.svg" alt="">
      Agenda
      <div class="active-marker"></div>
    </a>

    <div
      *ngIf="!enableNewReactApp"
      class="sidenav-item"
      routerLink="/agenda"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/clipboard-copy.svg" alt="">
      Agenda
      <div class="active-marker"></div>
    </div>

    <a
      class="sidenav-item sidenav-item--external"
      *ngIf="patient && enableNewReactApp"
      [href]="'/rc/patient/' + selectedFacilityId + '/profile/' + patient.id + '/forecast'"
      target="_self"
      title="Open Forecast in the new app"
    >
      <img src="/assets/edit_calendar.svg" alt="">
      Forecast
      <div class="active-marker"></div>
    </a>

    <div
      class="sidenav-item"
      *ngIf="patient && !enableNewReactApp"
      [routerLink]="['/patient', selectedFacilityId, 'profile', this.patient.id, 'forecast']"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/edit_calendar.svg" alt="">
      Forecast
      <div class="active-marker"></div>
    </div>

    <div
      *ngIf="hasCoSignPermission"
      class="sidenav-item"
      routerLink="/co-sign"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/co-sign.svg" alt="">
      Co-sign
      <div class="active-marker"></div>
    </div>

    <a
      class="sidenav-item sidenav-item--external"
      *ngIf="patient && enableNewReactApp"
      [href]="'/rc/patient/' + selectedFacilityId + '/profile/' + patient.id + '/billing'"
      target="_self"
      title="Open Therapy Billing in the new app"
    >
      <img src="/assets/billing.svg" alt="">
      Therapy Billing
      <div class="active-marker"></div>
    </a>

    <div
      class="sidenav-item"
      *ngIf="patient && !enableNewReactApp"
      [routerLink]="['/patient', selectedFacilityId, 'profile', this.patient.id, 'billing']"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/billing.svg" alt="">
      Therapy Billing
      <div class="active-marker"></div>
    </div>

    <div
      class="sidenav-item"
      *ngIf="patient"
      [routerLink]="['/patient', selectedFacilityId, 'profile', this.patient.id, 'documentation']"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/document.svg" alt="">
      Documentation
      <div class="active-marker"></div>
    </div>

    <div
      class="sidenav-item"
      routerLink="/time-card"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/clock.png" alt="">
      Timecard
      <div class="active-marker"></div>
    </div>

    <div
      class="sidenav-item"
      routerLink="/reports"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/leaderboard.svg" alt="">
      Reports
      <div class="active-marker"></div>
    </div>

    <div
      *ngIf="hasBiToolAccess"
      class="sidenav-item"
      [routerLink]="['/' + appRoutes.biDashboard]"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/dashboard-icon.svg" alt="">
      {{ biDashboardConstants.title }}
      <div class="active-marker"></div>
    </div>

    <div
      *ngIf="hasCloseOutAccess"
      class="sidenav-item"
      routerLink="/close-out"
      [routerLinkActive]="['active']"
    >
      <img src="/assets/check-circle.svg" alt="">
      Close Outs
      <div class="active-marker"></div>
    </div>
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
